(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eloura-routine-image"] && !Shopify.designMode) return;
  try {
    
  const initRoutineImage = () => {
    document.querySelectorAll('.eloura-routine-image-section').forEach((section) => {
      if (section.dataset.routineImageReady === 'true') return;
      section.dataset.routineImageReady = 'true';
      const updateHeight = () => {
        section.style.setProperty('--eloura-routine-image-top', `${Math.max(0, section.getBoundingClientRect().top + window.scrollY)}px`);
      };
      updateHeight();
      window.addEventListener('resize', updateHeight, { passive: true });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRoutineImage, { once: true });
  } else {
    initRoutineImage();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
